import classNames from 'classnames';
import './label.scss';

export default function Label({ children, small, className, ...props }) {
  return (
    <label
      className={classNames('label', { 'label--small': small }, className)}
      {...props}
    >
      {children}
    </label>
  );
}
